export const fontScaleLg = 1.4;
export const fontScaleRg = 1.3;
export const fontScaleMd = 1.2;
export const fontScaleSm = 1.1;
export const fontScaleCom = 1;
export const fontScaleField= 1.2;
export const allowFontScaleTrue = true;
export const allowFontScaleFalse = false;